import { send } from 'server';

import * as helpers from './helpers';

export const getSportsbookGamingHistory = ({ startDate, endDate, pageId, pageSize }) => send({
    ID: 32012,
    responses: [32013, 32014],
    description: 'Get Sportsbook Gaming History',
    startDate: helpers.formatDateForIms(startDate),
    endDate: helpers.formatDateForIms(endDate),
    clientType: 'sportsbook',
    orderByDate: 'desc',
    returnSummary: false,
    transactionGroups: [],
    ignorePlayerViewConf: false,
    ignoreStartingEndingBalances: true,
    pagerRequest: {
        pageSize,
        returnTotalCount: true,
        returnAllPageIds: true,
        ...pageId && { pageId }
    }
});
